


























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    legalPaymentPeriodCompliance: boolean | null;
    clientCashingDate: string | null;
    supplierPaymentDate: string | null;
}

@Component({ components: { SimpleText } })
export default class PaymentPeriod extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.legalPaymentPeriodCompliance",
            "insertion.clientCashingDate",
            "insertion.supplierPaymentDate",
        ];
    }

    public get colorIcon(): string {
        if (this.insertion.legalPaymentPeriodCompliance === true) {
            return "success-pastel";
        } else if (this.insertion.legalPaymentPeriodCompliance === false) {
            return "error-pastel";
        }
        return "info-pastel";
    }
}
